/* Homix redesign — small vanilla helpers (no dependencies) */
(function () {
  var isAr = (document.documentElement.lang || '').indexOf('ar') === 0;
  function digits(n) {
    var s = String(n).padStart(2, '0');
    return s;
  }
  function parts(ms) {
    var t = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(t / 86400); t -= d * 86400;
    var h = Math.floor(t / 3600); t -= h * 3600;
    var m = Math.floor(t / 60);
    return { d: d, h: h, m: m, s: t - m * 60 };
  }
  function midnight() { var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1).getTime(); }

  function tickCountdowns() {
    document.querySelectorAll('[data-hx-countdown]').forEach(function (el) {
      var endAttr = el.getAttribute('data-end');
      var end = endAttr === 'midnight' ? midnight() : Date.parse(endAttr);
      if (isNaN(end)) return;
      var left = end - Date.now();
      if (left <= 0 && el.hasAttribute('data-hide-when-done')) {
        var box = el.closest('[data-hx-hide-root]'); if (box) box.hidden = true;
      }
      var p = parts(left);
      ['d', 'h', 'm', 's'].forEach(function (k) {
        var slot = el.querySelector('[data-' + k + ']'); if (slot) slot.textContent = digits(p[k]);
      });
      var inline = el.querySelector('[data-inline]');
      if (inline) inline.textContent = (endAttr === 'midnight' ? '' : digits(p.d) + ' : ') + digits(p.h) + ':' + digits(p.m) + ':' + digits(p.s);
    });
  }

  function initSliders(root) {
    (root || document).querySelectorAll('[data-hx-slider]:not([data-ready])').forEach(function (s) {
      s.setAttribute('data-ready', '');
      var track = s.querySelector('.hx-slider__track');
      var slides = s.querySelectorAll('.hx-slider__slide');
      var dots = s.querySelectorAll('.hx-slider__dot');
      var n = slides.length, i = 0, timer;
      if (n < 2) return;
      var rtl = getComputedStyle(s).direction === 'rtl';
      function go(k) {
        i = (k + n) % n;
        track.style.transform = 'translateX(' + (rtl ? i * 100 : -i * 100) + '%)';
        dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        slides.forEach(function (sl, j) { sl.setAttribute('aria-hidden', j === i ? 'false' : 'true'); sl.tabIndex = j === i ? 0 : -1; });
      }
      function auto() { clearInterval(timer); var sec = parseInt(s.getAttribute('data-autoplay') || '0', 10); if (sec > 0) timer = setInterval(function () { go(i + 1); }, sec * 1000); }
      s.querySelector('[data-prev]') && s.querySelector('[data-prev]').addEventListener('click', function () { go(i - 1); auto(); });
      s.querySelector('[data-next]') && s.querySelector('[data-next]').addEventListener('click', function () { go(i + 1); auto(); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); auto(); }); });
      var x0 = null;
      s.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      s.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { go(i + ((dx < 0) !== rtl ? 1 : -1)); auto(); }
      });
      go(0); auto();
    });
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-hx-tabs]:not([data-ready])').forEach(function (w) {
      w.setAttribute('data-ready', '');
      var tabs = w.querySelectorAll('[data-hx-tab]');
      var panels = w.querySelectorAll('[data-hx-panel-id]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          var id = t.getAttribute('data-hx-tab');
          tabs.forEach(function (o) { o.setAttribute('aria-pressed', o === t ? 'true' : 'false'); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-hx-panel-id') === id); });
          w.dispatchEvent(new CustomEvent('hx:tab'));
        });
      });
    });
  }


  function hxTrack(c) { return c.querySelector('.hx-panel.is-active [data-hx-track]') || c.querySelector('[data-hx-track]'); }
  function hxUpdate(c) {
    var t = hxTrack(c); if (!t) return;
    var prev = c.querySelector('[data-hx-prev]'), next = c.querySelector('[data-hx-next]'), bar = c.querySelector('[data-hx-progress]');
    var max = t.scrollWidth - t.clientWidth; var x = Math.abs(t.scrollLeft);
    if (prev) prev.classList.toggle('is-off', x <= 2);
    if (next) next.classList.toggle('is-off', max <= 2 || x >= max - 2);
    if (bar) bar.style.width = (max <= 0 ? 100 : Math.max(12, Math.round(((x + t.clientWidth) / t.scrollWidth) * 100))) + '%';
  }
  function hxGo(c, dir) {
    var t = hxTrack(c); if (!t) return;
    var card = t.firstElementChild;
    var gap = parseFloat(getComputedStyle(t).columnGap); if (isNaN(gap)) gap = 10;
    var w = card ? card.getBoundingClientRect().width + gap : t.clientWidth;
    var per = Math.max(1, Math.floor((t.clientWidth + gap) / w));
    var rtl = getComputedStyle(t).direction === 'rtl';
    t.scrollBy({ left: (rtl ? -1 : 1) * dir * w * per, behavior: 'smooth' });
    setTimeout(function () { hxUpdate(c); }, 450);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hx-prev],[data-hx-next]');
    if (!b) return;
    var c = b.closest('[data-hx-carousel]'); if (!c) return;
    e.preventDefault(); e.stopPropagation();
    hxGo(c, b.hasAttribute('data-hx-next') ? 1 : -1);
  }, true);
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-hx-carousel]:not([data-ready])').forEach(function (c) {
      c.setAttribute('data-ready', '');
      c.querySelectorAll('[data-hx-track]').forEach(function (t) { t.addEventListener('scroll', function () { hxUpdate(c); }, { passive: true }); });
      c.addEventListener('hx:tab', function () { var t = hxTrack(c); if (t) t.scrollLeft = 0; hxUpdate(c); });
      window.addEventListener('resize', function () { hxUpdate(c); });
      window.addEventListener('load', function () { hxUpdate(c); });
      hxUpdate(c);
    });
  }


  function initCollection(root) {
    (root || document).querySelectorAll('[data-hx-coll]:not([data-ready])').forEach(function (c) {
      c.setAttribute('data-ready', '');
      var panel = c.querySelector('[data-hx-filters]'), back = c.querySelector('.hx-filters-backdrop');
      var mq = window.matchMedia('(max-width: 989px)');
      function open(on) { if (!panel) return; panel.classList.toggle('is-open', on); if (back) back.hidden = !on; document.documentElement.style.overflow = on ? 'hidden' : ''; }
      c.querySelectorAll('[data-hx-filters-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(true); }); });
      c.querySelectorAll('[data-hx-filters-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(false); }); });
      var form = c.querySelector('#hx-filter-form');
      if (form) form.addEventListener('change', function () { if (!mq.matches) form.requestSubmit ? form.requestSubmit() : form.submit(); });
      var sort = c.querySelector('[data-hx-sort]');
      if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });
      var view = c.querySelector('[data-hx-view]');
      if (view) view.addEventListener('click', function (e) { e.preventDefault(); c.setAttribute('data-view', c.getAttribute('data-view') === '1' ? '2' : '1'); });
      var more = c.querySelector('[data-hx-more]');
      if (more) more.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-hx-more-btn]'); if (!btn) return;
        e.preventDefault(); btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.6';
        fetch(btn.href, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = c.querySelector('[data-hx-results]'), ng = doc.querySelector('[data-hx-results]');
          if (grid && ng) Array.prototype.forEach.call(ng.querySelectorAll('.hx-card'), function (card) { grid.appendChild(card); });
          var nm = doc.querySelector('[data-hx-more]');
          if (nm) { more.innerHTML = nm.innerHTML; }
          history.replaceState(null, '', btn.href);
        }).catch(function () { location.href = btn.href; });
      });
    });
  }


  function initNav() {
    var bar = document.querySelector('.hdt-toolbar'); if (!bar) return;
    var path = location.pathname.replace(/\/(ar|en)(?=\/|$)/, '') || '/';
    var items = bar.querySelectorAll('.hdt-toolbar-item'), hit = null;
    items.forEach(function (it) {
      var a = it.querySelector('a[href]'); if (!a) return;
      var hp = new URL(a.href, location.origin).pathname.replace(/\/(ar|en)(?=\/|$)/, '') || '/';
      if (hp === path || (hp !== '/' && path.indexOf(hp) === 0)) hit = it;
    });
    if (!hit && (path === '/' || path === '')) hit = bar.querySelector('.hdt-toolbart-home');
    if (!hit && /\/cart/.test(path)) hit = bar.querySelector('.hdt-toolbart-cart');
    if (!hit && /\/(collections|products)/.test(path)) hit = bar.querySelector('.hdt-toolbart-nav');
    items.forEach(function (it) { it.classList.toggle('hx-active', it === hit); });
  }


  function initSearchbar(root) {
    (root || document).querySelectorAll('[data-hx-searchbar]:not([data-ready])').forEach(function (b) {
      b.setAttribute('data-ready', '');
      var inp = b.querySelector('input[data-hx-ph]'); if (!inp) return;
      var list = (inp.getAttribute('data-hx-ph') || '').split('||').map(function (x) { return x.trim(); }).filter(Boolean);
      if (list.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      setInterval(function () { if (document.activeElement === inp || inp.value) return; i = (i + 1) % list.length; inp.setAttribute('placeholder', list[i]); }, 2800);
    });
  }
  function initDeals(root) {
    (root || document).querySelectorAll('[data-hx-deals]:not([data-ready])').forEach(function (s) {
      s.setAttribute('data-ready', '');
      var grid = s.querySelector('[data-hx-deals-grid]'); if (!grid) return;
      var limit = parseInt(grid.getAttribute('data-limit'), 10) || 10;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.hx-dcard')), empty = s.querySelector('[data-hx-deals-empty]');
      s.querySelectorAll('[data-hx-tier]').forEach(function (b) {
        b.addEventListener('click', function () {
          var min = parseInt(b.getAttribute('data-hx-tier'), 10) || 0;
          var max = parseInt(b.getAttribute('data-hx-tier-max'), 10); if (isNaN(max)) max = 100;
          var shown = 0;
          s.querySelectorAll('[data-hx-tier]').forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          cards.forEach(function (c) {
            var off = parseInt(c.getAttribute('data-off'), 10) || 0;
            var ok = off >= min && off <= max && shown < limit;
            c.hidden = !ok; if (ok) shown++;
          });
          if (empty) empty.hidden = shown > 0;
        });
      });
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.hx-cart-code[data-hx-copy]');
    if (!b) return;
    e.preventDefault();
    var code = b.getAttribute('data-hx-copy');
    var drawerInput = document.querySelector('#CartDrawer input[name="discount"], #CartDrawer .hdt-discount-input-wrapper input');
    if (drawerInput) { drawerInput.value = code; drawerInput.dispatchEvent(new Event('input', { bubbles: true })); }
    if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
    b.setAttribute('data-copied', ''); setTimeout(function () { b.removeAttribute('data-copied'); }, 2000);
  });

  function initCodes(root) {
    (root || document).querySelectorAll('[data-hx-copy]:not([data-ready]):not(.hx-cart-code)').forEach(function (b) {
      b.setAttribute('data-ready', '');
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var code = b.getAttribute('data-hx-copy');
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { b.setAttribute('data-copied', ''); setTimeout(function () { b.removeAttribute('data-copied'); }, 2000); });
      });
    });
  }

  function initPdp(root) {
    (root || document).querySelectorAll('[data-hx-inst]:not([data-ready])').forEach(function (w) {
      w.setAttribute('data-ready', '');
      var note = w.querySelector('[data-note]');
      var price = parseInt(w.getAttribute('data-price'), 10) || 0;
      var fmt = w.getAttribute('data-money');
      var btns = w.querySelectorAll('[data-provider]');
      function money(cents) {
        var v = Math.ceil(cents / 100);
        return v.toLocaleString('en-US') + ' ' + fmt;
      }
      function pick(b) {
        btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        var months = parseInt(b.getAttribute('data-months'), 10) || 0;
        var name = b.getAttribute('data-provider');
        var extra = b.getAttribute('data-offer') || '';
        note.textContent = months > 0
          ? w.getAttribute('data-t-months').replace('{p}', name).replace('{a}', money(price / months)).replace('{m}', months) + (extra ? ' — ' + extra : '')
          : w.getAttribute('data-t-nomonths').replace('{p}', name) + (extra ? ' — ' + extra : '');
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { pick(b); }); });
      if (btns[0]) pick(btns[0]);
      document.addEventListener('variant:change', function (e) {
        var v = e.detail && (e.detail.variant || e.detail); if (v && v.price) { price = v.price; var cur = w.querySelector('[aria-pressed="true"]'); if (cur) pick(cur); }
      });
    });
  }

  function initAll(root) { if (!root || root === document) { try { hxHeadHeight(); } catch (e) {} } [initSliders, initTabs, initCarousels, initCodes, initPdp, initCollection, initNav, initSearchbar, initDeals].forEach(function (fn) { try { fn(root); } catch (err) { console.error('homix', err); } }); tickCountdowns(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  setInterval(tickCountdowns, 1000);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
